import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isCoach } from '../utils/adminUtils';
import { Box, Typography, Alert } from '@mui/material';

const AdminRoute = ({ children }) => {
  const { currentUser, approvedCoachUids } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (currentUser.isAnonymous) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Trenerio / administratoriaus prieiga reikalauja prisijungimo
        </Alert>
        <Typography variant="body1">
          Anoniminiai vartotojai negali pasiekti šio puslapio.
        </Typography>
      </Box>
    );
  }

  if (!isCoach(currentUser, approvedCoachUids)) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          Neturite trenerio ar administratoriaus teisių
        </Alert>
        <Typography variant="body1">
          Tik treneriai ir administratoriai gali pasiekti šį puslapį.
        </Typography>
      </Box>
    );
  }

  return children;
};

export default AdminRoute; 